<template>
  <v-btn 
    small
    class="rounded-lg text-none font-weight-regular"
    color="grey darken-2 white--text"
    @click="$emit('click', this)"
    depressed
  >
    <slot></slot>
  </v-btn>
</template>

<script>
  /** Standard action button for this project */
  export default {
    name:'BasePopupBtn'
  }
</script>

<style lang="scss" scoped>

</style>